import React, { Component } from 'react';

import commonUtil from '../../../../../../utils/commonUtil';

const channel = commonUtil.getChannel();

class AddressName extends Component {
  render() {
    const props = this.props;
    const className = props.className;
    const openAddressWap = props.openAddressWap;
    const addressDescriptionFlag = props.addressDescriptionFlag;

    return (
      <h3
        className={className}
        onClick={openAddressWap ? this.props.openAddressWap : () => {}}
      >
        {commonUtil.sentenceCase(this.props.nickName)}
        {
          ((channel === 'wap' && addressDescriptionFlag) && <i className="icon-flecha_lightsvg_derecha" />)
        }
      </h3>
    );
  }
}

export default AddressName;
